import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/user';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import Paper from 'material-ui/Paper';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
  } from 'material-ui/Table';
  import RaisedButton from 'material-ui/RaisedButton';
  import { validateEmail } from '../../utils/misc';
  import {
    CREATE_USER_SUCCESS,
    DELETE_USER_SUCCESS,
} from '../../constants';

function mapStateToProps(state) {
    return {
        data: state.user,
        token: state.auth.token,
        loaded: state.user.loaded,
        action: state.user.action,
        isFetching: state.user.isFetching,
        isCreating: state.user.isCreating, 
        statusText: state.auth.statusText,
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

@connect(mapStateToProps, mapDispatchToProps)
export default class UsersListView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fixedHeader: true,
            fixedFooter: true,
            showCheckboxes: false,
            formStateOpen: false,
            first_name: '',
            last_name: '',
            username: '',
            password: '',
            email: '',
            role_id: 1,
            userToDelete: null,
            username_error_text: null,
            password_error_text: null,
            first_name_error_text: null,
            last_name_error_text: null,
            email_error_text: null,
            role_erroer_text: null,
            disabled: true,
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.action == CREATE_USER_SUCCESS) {
            this.handleFormClose();
            this.fetchData();
        }

        if (nextProps.action == DELETE_USER_SUCCESS) {
            this.fetchData();
        }
    }

    isDisabled() {
        let email_is_valid = false;
        let password_is_valid = false;
        let username_is_valid = false;

        //email check
        if (this.state.email === '') {
            this.setState({
                email_error_text: null,
            });
        } else if (validateEmail(this.state.email)) {
            email_is_valid = true;
            this.setState({
                email_error_text: null,
            });

        } else {
            this.setState({
                email_error_text: 'Sorry, this is not a valid email',
            });
        }
        //password chehck
        if (this.state.password === '' || !this.state.password) {
            this.setState({
                password_error_text: null,
            });
        } else if (this.state.password.length >= 6) {
            password_is_valid = true;
            this.setState({
                password_error_text: null,
            });
        } else {
            this.setState({
                password_error_text: 'Your password must be at least 6 characters',
            });
        }
        //username check
        if (this.state.username === '' || !this.state.username) {
            this.setState({
                username_error_text: null,
            });
        } else if (this.state.password.length >= 0) {
            username_is_valid = true;
            this.setState({
                username_error_text: null,
            });
        } else {
            this.setState({
                username_error_text: 'Your username must be filled',
            });

        }

        if (username_is_valid && email_is_valid && password_is_valid) {
            this.setState({
                disabled: false,
            });
        }
    }

    changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state, () => {
            this.isDisabled();
        });
    }

    fetchData() {
        const token = this.props.token;
        this.props.fetchUsersData(token);
    }
    
    handleFormOpen = (user) => {
        this.setState({formStateOpen: true, userToDelete: user});
      };
    
    handleFormClose = () => {
        this.setState({formStateOpen: false});
    };
    
    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            if (!this.state.disabled) {
                this.createUser(e)
            }
        }
    }   

    handleSelectChange = (event, index, value) => {
        this.setState({role_id: value});
    }

    createUser(e) {
        e.preventDefault();
        let user = {
            username: this.state.username,
            password: this.state.password,
            email: this.state.email,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            role_id: this.state.role_id,

        }
        this.props.createUser(user, this.props.token)
    }

    deleteUser(e, id) {
        e.preventDefault();
        this.props.deleteUser(id, this.props.token)
    }

    viewUser(e, id) {
        browserHistory.push({
            pathname: '/admin/user',
            state: { userId: id }
        })
    }
    
    render() {
        const actions = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleFormClose}
          />,
          <FlatButton
            label="Submit"
            primary={true}
            disabled={this.state.disabled}
            onClick={(e) => this.createUser(e)}
          />,
        ];
        return (
            <div>
                {!this.props.loaded
                    ? <h3>Loading data...</h3>
                    :
                    <div className="container">
                        <div className="row">
                            <div className="pull-right">
                                <RaisedButton
                                style={{ marginTop: 25, marginBottom: 25 }}
                                primary
                                label="Create"
                                onClick={(e) => this.handleFormOpen()}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <Paper >
                                <Table fixedHeader={this.state.fixedHeader}
                                    fixedFooter={this.state.fixedFooter}>
                                    <TableHeader 
                                        displaySelectAll={this.state.showCheckboxes}
                                        adjustForCheckbox={this.state.showCheckboxes}>
                                    <TableRow>
                                        <TableHeaderColumn>ID</TableHeaderColumn>
                                        <TableHeaderColumn>Username</TableHeaderColumn>
                                        <TableHeaderColumn>First Name</TableHeaderColumn>
                                        <TableHeaderColumn>Last Name</TableHeaderColumn>
                                        <TableHeaderColumn>Email</TableHeaderColumn>
                                        <TableHeaderColumn>Role</TableHeaderColumn>
                                        <TableHeaderColumn></TableHeaderColumn>
                                        <TableHeaderColumn></TableHeaderColumn>
                                    </TableRow>
                                    </TableHeader>
                                    <TableBody displayRowCheckbox={this.state.showCheckboxes}>
                                    {this.props.data.data && this.props.data.data.map(row => {
                                        return (
                                        <TableRow key={row.id}>
                                            <TableRowColumn>{row.id}</TableRowColumn>
                                            <TableRowColumn>{row.username}</TableRowColumn>
                                            <TableRowColumn>{row.first_name}</TableRowColumn>
                                            <TableRowColumn>{row.last_name}</TableRowColumn>
                                            <TableRowColumn>{row.email}</TableRowColumn>
                                            <TableRowColumn>{row.role.name}</TableRowColumn>
                                            <TableRowColumn>
                                                <FlatButton label="View" onClick={(e) => this.viewUser(e, row.id)}/>
                                            </TableRowColumn>
                                            <TableRowColumn>
                                                <FlatButton label="Delete" onClick={(e) => this.deleteUser(e, row.id)}/>
                                            </TableRowColumn>
                                        </TableRow>
                                        );
                                    })}
                                    </TableBody>
                                </Table>            
                            </Paper>
                            </div>
                        <Dialog
                            title="Create New User"
                            actions={actions}
                            modal={true}
                            open={this.state.formStateOpen}
                            >
                            <div className="col-md-6 col-md-offset-3" onKeyPress={(e) => this._handleKeyPress(e)}>
                                    <form role="form">
                                        <div className="text-center">
                                            <div className="col-md-12">
                                                <TextField
                                                    hintText="First Name"
                                                    floatingLabelText="First Name"
                                                    type="text"
                                                    errorText={this.state.first_name_error_text}
                                                    onChange={(e) => this.changeValue(e, 'first_name')}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <TextField
                                                    hintText="Last Name"
                                                    floatingLabelText="Last Name"
                                                    type="text"
                                                    errorText={this.state.last_name_error_text}
                                                    onChange={(e) => this.changeValue(e, 'last_name')}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <TextField
                                                    hintText="Username"
                                                    floatingLabelText="Username"
                                                    type="username"
                                                    errorText={this.state.username_error_text}
                                                    onChange={(e) => this.changeValue(e, 'username')}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <TextField
                                                    hintText="Email"
                                                    floatingLabelText="Email"
                                                    type="email"
                                                    errorText={this.state.email_error_text}
                                                    onChange={(e) => this.changeValue(e, 'email')}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <TextField
                                                    hintText="Password"
                                                    floatingLabelText="Password"
                                                    type="password"
                                                    errorText={this.state.password_error_text}
                                                    onChange={(e) => this.changeValue(e, 'password')}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <SelectField
                                                    floatingLabelText="Role"
                                                    value={this.state.role_id}
                                                    onChange={this.handleSelectChange}
                                                    >
                                                    <MenuItem value={1} primaryText="Admin" />
                                                    <MenuItem value={2} primaryText="Client" />
                                                </SelectField>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </Dialog>
                    </div>
                }
            </div>
        );
    }
}

UsersListView.propTypes = {
    fetchProtectedData: React.PropTypes.func,
    loaded: React.PropTypes.bool,
    userName: React.PropTypes.string,
    data: React.PropTypes.any,
    token: React.PropTypes.string,
    statusText: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Admin/UsersListView.js